import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TemplateType } from '../../../../core/enums';
import { Blocker } from '../../../../core/models';
import { BlockerService } from '../../../../core/services/blocker.service';

@Component({
  selector: 'kt-workflow-add-blocker-dialog',
  templateUrl: './workflow-add-blocker-dialog.component.html',
})
export class WorkflowAddBlockerDialogComponent implements OnInit {
  TemplateType = TemplateType;
  form: FormGroup;
  emitBlockers = false;
  blockers: Partial<Blocker>[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      workflowGroup: string;
      workflows: any[];
    },
    private dialogRef: MatDialogRef<WorkflowAddBlockerDialogComponent>,
    private formBuilder: FormBuilder,
    private blockerService: BlockerService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({ workflowId: ['', Validators.required] });
  }

  isInvalid(name: string): boolean {
    const field = this.form.get(name);

    return field.touched && field.invalid;
  }

  getErrorMessage(name: string): string {
    return `${name} field is required`;
  }

  updateBlockers(blockers: Partial<Blocker>[]): void {
    this.blockers = blockers;
  }

  cancel(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close(false);
  }

  save(event: Event): void {
    event.stopPropagation();

    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    this.emitBlockers = true;

    setTimeout(() => {
      this.blockerService
        .createUpdateBlockers(
          this.form.get('workflowId')?.value,
          TemplateType.WORKFLOW,
          this.blockers,
        )
        .pipe(take(1))
        .subscribe((res) => {
          if (!res) return;

          this.dialogRef.close(true);
        });
    });
  }
}
